import { withViewModel } from '../../../../../../../../../infrastructure/components/with-view-model';
import { IAccountContactDTO } from '../../../../../../../../../api/account-contacts.dao';
import { SpeakerFormVM } from './speaker-form.viewmodel';
import { SpeakerFormPresentation } from './speaker-form-presentation';

interface ISpeakerFormModalContainerProps {
    accountId: number;
    speaker?: IAccountContactDTO;
    onCancel: () => void;
    onConfirm: (contact: IAccountContactDTO) => void;
}

const SpeakerFormModal = withViewModel(
    SpeakerFormPresentation,
    async (props: ISpeakerFormModalContainerProps) => {
        const speakerFormVM = props.speaker
            ? SpeakerFormVM.createFromSpeakerDTO(props.speaker, props.accountId, props.onCancel, props.onConfirm)
            : SpeakerFormVM.createEmpty(props.accountId, props.onCancel, props.onConfirm);
        void speakerFormVM.loadOrganizations();
        return speakerFormVM;
    },
    () => []
);

export { SpeakerFormModal };